import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../store";

const initialState = {
  token: "",
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    logout: (state) => {
      state.token = "";
    },
  },
});

export const { logout, setToken } = authSlice.actions;
export const selectCurrentToken = (state: RootState) => state.auth.token;
export default authSlice.reducer;
